module.exports = __webpack_public_path__ + "img/emotion-hate.cb2cd0d9.svg";